const ProjectDetails = [
{
    id: "1",
    projectName: "Camera House",
    description: "Camera House Website Is For Selling Different Types of Camera In Online. People Will Be Able To Order Camera In Online Through Camera House Website. It Is User Friendly Website So Anyone Can Order Their Camera Very Easily.",
    imageOne: "https://i.ibb.co/VWVX5zj/screencapture-camera-house-36682-web-app-dashboard-2021-12-01-13-34-35.png",
    imageTwo: "https://i.ibb.co/tbPHh3b/screencapture-camera-house-36682-web-app-explore-2021-12-01-13-35-20.png",
    imageThree: "https://i.ibb.co/MpQKZLT/screencapture-camera-house-36682-web-app-review-2021-12-01-13-35-52.png",
    liveSite: "https://camera-house-36682.web.app/",
    githubCode: "https://github.com/Shishirsaha1530/Camera_House_Client_Side",
    gitHuBack: "https://github.com/Shishirsaha1530/Camera_house_Project",
    featureOne: "Without Login Anyone Will Be Able To Use The Website But He Cant Be Able To Order Camera Without Login Into The Website.", 
    featureTwo: "After Logging Into The Webste User Will Be Able To See His Dashboard. From Dashboard User Will be Able Manage His Order and Write Review For The Website. Payment System Will Come Soon.", 
    featureThree: "Website Admin Will Be Able To Manage Order, Manage Product, Can Be Able To Make Another Registered User Admin and Will Be Able To Add Product Into The Website.", 
    featureFour: "From Managing Order Admin Will be Able To Update The Order Using Input Text and Update Button. Admin Will Be Also Able To Delete Any Order That He Wants To.", 
    featureFive: "From Add Product Option Admin Will Be Able To Add Camera Into The Webste.", 
    featureSix: "From Managing Product Option Admin Will Be Able To Remove Any Product From The Website.",
    technology: "React JS, Node JS, Express JS, MongoDB, AOS Animation, Firebase Authentication, Bootstrap 5, Heroku, Firebase Hosting" 
},
{
    id: "2",
    projectName: "GhuriFiri Travels",
    description: "GhuriFiri is a online based travel agency. From This website peolpe can be able to book any destination of Bangladesh. This is a user friendy website for the people who loves to travel.",
    imageOne: "https://i.ibb.co/9vMsyD3/screencapture-youthful-snyder-38bd7b-netlify-app-2021-12-01-13-44-59.png",
    imageTwo: "https://i.ibb.co/R44d67P/screencapture-youthful-snyder-38bd7b-netlify-app-login-2021-12-01-13-46-29.png",
    imageThree: "https://i.ibb.co/8dh640p/screencapture-youthful-snyder-38bd7b-netlify-app-package-2021-12-01-13-47-31.png",
    liveSite: "https://youthful-snyder-38bd7b.netlify.app/",
    githubCode: "https://github.com/Shishirsaha1530/GhuriFiri_Client_Side",
    gitHuBack: "https://github.com/Shishirsaha1530/GhuriFiri_Server_Side",
    featureOne: "People can be able to book any package he loves.", 
    featureTwo: "User can be login into the website using their Gmail. After logging into the website user can be able to book any travel package after filling the order form.", 
    featureThree: "Admin can able to add new package in the system. He can also manage all bookings from the system.", 
    featureFour: "Admin can approve and delete order after login and from dashboard manage order option.", 
    featureFive: "Admin can dynamically add any package.", 
    featureSix: "User friendy Website and easy to use.",
    technology: "React JS, Node JS, Express JS, MongoDB, Firebase Authentication, Bootstrap 5, Material UI, Heroku, Netlify Hosting." 
},
{
    id: "3",
    projectName: "Fitness Zone",
    description: "This is a health care related website. This website will help you to get important tips and exercise to keep yourself fit in both mentally and physically. People can be able to see different package for different categories and can read different health related blogs from here.",
    imageOne: "https://i.ibb.co/gzhwwQJ/screencapture-elegant-cray-3e5e3d-netlify-app-home-2021-12-01-13-55-10.png",
    imageTwo: "https://i.ibb.co/cCBh5FS/screencapture-elegant-cray-3e5e3d-netlify-app-login-2021-12-01-13-55-43.png",
    imageThree: "https://i.ibb.co/nDmkH25/screencapture-elegant-cray-3e5e3d-netlify-app-service-2021-12-01-13-56-06.png",
    liveSite: "https://elegant-cray-3e5e3d.netlify.app/",
    githubCode: "https://github.com/Shishirsaha1530/Health_Care_Website",
    gitHuBack: "https://github.com/Shishirsaha1530/Health_Care_Website",
    featureOne: "People Can Read Health Related Blogs and Can Be Able to Join in Different Health Related Class.", 
    featureTwo: "Blog Reading and Contact Page Feature is Private Page. People Need To Login Before Using This Features", 
    featureThree: "People Can Register Themself from Website Using Direct Google Login and Manual Email and Password Login.", 
    featureFour: "Anyone without login Can Visit the Website But They Can't be Able to See Different Package Details Without Login.", 
    featureFive: "People Will Be Able to Get Information Related To Mental and Health Issue.", 
    featureSix: "This Website is User Friendly for Any Age User's.",
    technology: "Blog reading and contact page feature is private page. User need to login before using these features." 
},
{
    id: "4",
    projectName: "Corona Virus Tracker App",
    description: "This Site Will Help You To Provice Country Wise Corona Update. Type The Country Name In The Input Field And You Will Get Update On That Country.",
    imageOne: "https://i.ibb.co/T0WWfbV/screencapture-corona-virus-trackerapp-netlify-app-2021-12-01-14-04-37.png",
    imageTwo: "https://i.ibb.co/LC1c8Vm/screencapture-corona-virus-trackerapp-netlify-app-2021-12-01-14-08-03.png",
    imageThree: "https://i.ibb.co/sv615J0/screencapture-corona-virus-trackerapp-netlify-app-2021-12-01-14-05-20.png",
    liveSite: "https://corona-virus-trackerapp.netlify.app/",
    githubCode: "https://github.com/Shishirsaha1530/Corona_Virus_Tracker_App",
    gitHuBack: "https://github.com/Shishirsaha1530/Corona_Virus_Tracker_App",
    featureOne: "This app will help to give daily country based updates on corona virus.", 
    featureTwo: "User needs to type the country name in the input box. Then it will show daily statistics.", 
    featureThree: "If someone doesn't type anything or put wrong country name it will show error message.", 
    featureFour: "App will give daily records and also total statistics of covid 19 based on country name.", 
    featureFive: "Very user friendly app to know the statistics.", 
    featureSix: "Automatic country name suggestion feature will be coming soon",
    technology: "Html, Css, JavaScript, Covid 19 api, Bootstrap" 
},

] 

export default ProjectDetails;







